import {useMutation, useQueryClient} from '@tanstack/react-query';
import {directoryService} from '../services/directory';
import {message} from 'antd';
import type {DeleteFolderParams} from '../types/directory';

export function useDelete(currentId?: number | string, clearSelection?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: { item: DeleteFolderParams[] }) => {
      if (!currentId) {
        throw new Error('缺少 currentId');
      }

      return directoryService.delete(params);
    },

    onMutate: async (params: { item: DeleteFolderParams[] }) => {
      if (!currentId) return;

      await queryClient.cancelQueries({
        queryKey: ['file-list', currentId]
      });

      const previousData = queryClient.getQueryData<any>(['file-list', currentId]);

      const deleteItems = params.item;
      const deleteIds = deleteItems.map((item: any) => item.id);

      queryClient.setQueryData(['file-list', currentId], (old: any) => {
        if (!old) return old;

        return {
          ...old,
          pages: old.pages.map((page: any) => ({
            ...page,
            items: page.items.filter((item: any) => !deleteIds.includes(item.id))
          }))
        };
      });

      return {
        previousData,
        hasDirectory: deleteItems.some((item: any) => item.type === 'directory'),
      };
    },

    onSuccess: (_res, _params, context: any) => {
      void message.success(_res || '删除成功');

      clearSelection?.();

      if (context?.hasDirectory) {
        void queryClient.invalidateQueries({
          queryKey: ['directory-tree']
        });
      }
    },

    onError: (_err, _params, context: any) => {
      if (context?.previousData && currentId) {
        queryClient.setQueryData(['file-list', currentId], context.previousData);
      }

      void message.error('删除失败');
    },

    onSettled: () => {
      if (!currentId) return;

      void queryClient.invalidateQueries({
        queryKey: ['file-list', currentId]
      });
    }
  });
}